/**
 * Stores Module
 *
 * Legend-State store configuration and global stores
 */

// Store creation helpers (recommended)
export { createPersistedStore, createStore, createSyncedPersistedStore } from './store.setup';

// Store utilities
export { getRegisteredStores } from './store.setup';

// Legacy sync plugin (for complex sync logic)
export { syncPluginStore, syncPluginWebStore } from './store.setup';
export type { SyncPluginWebStoreOptions, SyncedGetParams, SyncedSetParams } from './store.setup';

// Hydration utilities
export { hydrationState$, isStoreHydrated, waitForHydration } from './store.setup';

// IndexedDB utilities
export { isIndexedDBReady, waitForIndexedDB, initializeIndexedDBStores, clearPersistedStores } from './store.setup';

// Global store
export { globalStore$ } from './global.store';
export type { GlobalStore } from './global-store.types';

// Flash message store
export { flashMessageAPI, flashMessageStore$ } from './flash-message.store';
export type { FlashMessage, FlashMessageAPI } from './flash-message.store';
